export const environment = {
  production: true
};

export const GlobalNamespace: Object = {
  namespace: 'Equator',
  api: {
    property: {
      search: '/index.cfm?event=data.property.search',
      status: './assets/data/mock-property-status.json?',
      recentProperties: '/index.cfm?event=data.property.myRecentProperties',
      header: '/index.cfm?event=data.property.detail',
      changeLog: '/index.cfm?event=data.property.listPriceHistory',
      fcMilestoneHistory: '/index.cfm?event=data.property.fcMilestoneHistory',
      updateFavoriteProperties: '/index.cfm?event=data.property.updateMyFavoriteProperty',
      buildExcel: '/index.cfm?event=property.getSearchPropertyResultsExcel'
    },
    investor: {
      investorGroup: './assets/data/mock-investor-group.json?'
    },
    expense: {
      counter: '/index.cfm?event=data.property.expenseCount',
      search: '/index.cfm?event=data.expense.search'
    },
    task: {
      completedTask: '/index.cfm?event=data.task.myRecentTasks',
      counter: '/index.cfm?event=data.property.taskCount',
      list: '/index.cfm?event=data.task.property',
      taskToComplete: '/index.cfm?event=data.task.myCompletableTasks',
      assignedTasks: '/index.cfm?event=data.task.myAllTaskCount',
      search: '/index.cfm?event=data.task.search',
      buildExcel: '/index.cfm?event=property.getSearchTaskResultsExcel'
    },

    relationship: {
      relationshipType: '/index.cfm?event=data.general.RelationshipType',
      relationship: '/index.cfm?event=data.partner.relationship',
      relationshipById: '/index.cfm?event=data.partner.relationshipById',
      relationshipByPerson: '/index.cfm?event=data.partner.relationshipByPersonId',
      relationshipDataItem: '/index.cfm?event=data.partner.relationshipDataItem'
    },
    partner: {
      sourceData: '/index.cfm?event=data.partner.sourceData',
      sourceAssetId: '/index.cfm?event=data.partner.sourceAssetId',
      createPartner: '/index.cfm?event=data.partner.createPartner',
      updatePartnership: '/index.cfm?event=data.partner.updatePartnership',
      deletePartner: '/index.cfm?event=data.partner.deletePartner',
      deactivatePartner: '/index.cfm?event=data.partner.deactivatePartner',
      searchByEmail: '/index.cfm?event=data.person.searchByEmail',
      user: '/index.cfm?event=data.partner.user',
      relationshipGroupById: '/index.cfm?event=data.partner.relationshipGroupById',
      relationshipGroup: '/index.cfm?event=data.partner.relationshipGroup',
      deleteRelationshipGroup: '/index.cfm?event=data.partner.deleteRelationshipGroup',
      assetGroupNameExists: '/index.cfm?event=data.partner.existingRelationshipDataGroup',
      partnerTypePrivileges: '/index.cfm?event=data.security.privilege'
    },
    person: {
      getById : '/index.cfm?event=data.person.getById',
      update: '/index.cfm?event=data.person.updatePerson',
      emailOption: '/index.cfm?event=data.person.emailOption',
      noteAlterts : '/index.cfm?event=property.note_alerts'
    },
    general: {
      phone: '/index.cfm?event=data.general.phone',
      address: '/index.cfm?event=data.general.address',
      sendEmail: '/index.cfm?event=data.general.sendEmail'
    },
    security: {
      question: '/index.cfm?event=data.security.question',
      password: '/index.cfm?event=data.security.password'
    },
    user: {
      userRelationshipGroup: '/index.cfm?event=data.partner.userRelationshipGroup',
      relationshipGroupByPerson: '/index.cfm?event=data.partner.relationshipGroupByPersonId',
      update: '/index.cfm?event=data.partner.userRelationshipGroup',
      relationshipPrivilegeByPerson: '/index.cfm?event=data.security.privilege'
    },
    privilegeGroup: {
      userPrivilegeGroup: '/index.cfm?event=data.security.privilegeGroup',
      update: '/index.cfm?event=data.security.createPrivilegeGroup',
      delete: '/index.cfm?event=data.security.deletePrivilegeGroup'
    },
    setting: {
      partner: {
        save: '/index.cfm?event=data.configuration.relationship',
        type: '/index.cfm?event=data.general.RelationshipType',
        typeById: '/index.cfm?event=data.configuration.relationship'
      }
    },
    message: {
      send: '/index.cfm?event=data.message.send'
    },
    offer: {
      counter: '/index.cfm?event=data.property.offerCount',
      allOffers: '/index.cfm?event=data.offer.getOffers',
      updateOffer: '/index.cfm?event=data.offer.updateOffer'
    },
    changelog: {
      property: '/index.cfm?event=data.property.changelog'
    },
    auction: {
        data : '/index.cfm?event=data.Auction.auctionSearch',
        updateReservePrice: '/index.cfm?event=data.auction.updateReservePrice',
        changeLog: '/index.cfm?event=data.auction.auctionChangeLog',
        changeLogSelectors: '/index.cfm?event=data.auction.auctionChangeLog'
    },
    bidInstruction: {
      search: '/index.cfm?event=data.bidInstruction.search',
      availableTrustees: '/index.cfm?event=data.bidInstruction.getAvailableTrustees',
      create: '/index.cfm?event=data.bidInstruction.create',
      update: '/index.cfm?event=data.bidInstruction.updateBidMatrix',
      delete: '/index.cfm?event=data.bidInstruction.deleteBidMatrix',
      download: 'index.cfm?event=data.bidInstruction.downloadBidInstructionFile',
      buildExcel: 'index.cfm?event=data.bidInstruction.buildExcel',
      changeLog: 'index.cfm?event=data.bidInstruction.changeLog',
      changeLogSelectors: 'index.cfm?event=data.bidInstruction.changeLog',
      bidInstructionQueue:'index.cfm?event=data.bidInstruction.searchBidInstructionQueue' 
    },
    foreclosureAuctionLocation:{
      search: 'index.cfm?event=data.foreclosureAuctionMatrixLocation.search',
      create:'index.cfm?event=data.foreclosureAuctionMatrixLocation.create',
      update:'index.cfm?event=data.foreclosureAuctionMatrixLocation.updateForeclosureAuctionLocation',
      delete:'index.cfm?event=data.foreclosureAuctionMatrixLocation.deleteForeclosureAuctionLocation',
      changeLogSelectors: 'index.cfm?event=data.foreclosureAuctionMatrixLocation.changeLog',
      changeLog: 'index.cfm?event=data.foreclosureAuctionMatrixLocation.changeLog'
    },
    auctionFees:{
      search: 'index.cfm?event=data.auctionFees.search',
      create: '/index.cfm?event=data.auctionfees.create',
      update: '/index.cfm?event=data.auctionfees.updateAuctionFees',
      delete:'index.cfm?event=data.auctionfees.deleteAuctionFees',
      uniqueClientId : '/index.cfm?event=data.general.uniqueClientID',
      changeLogSelectors: 'index.cfm?event=data.auctionfees.changeLog',
      changeLog: 'index.cfm?event=data.auctionfees.changeLog'
    },
    county:'/index.cfm?event=data.general.county',
    allStates: '/index.cfm?event=data.general.states',
    states: './assets/data/mock-states.json?',
    baseEvent: '/index.cfm?event='
  },
  routes: {
    property: {
      viewTasks: '/index.cfm?event=property.viewTasks',
      library: '/index.cfm?event=property.property_library',
      noteSummaryAll: '/index.cfm?event=property.note_summary_all',
      noteSummaryAdd: '/index.cfm?event=property.note_summary_add',
      viewExpense: '/index.cfm?event=property.expenseTrackingView',
      viewOffer: '/index.cfm?event=property.view_all_offers',
      search: 'index.cfm?event=property.search',
      propertyPage : '/index.cfm?event=property.viewEvents',
      propertyNotes: '/index.cfm?event=property.property_notes'
    },
    person: {
      PartnerDetails: '/index.cfm?event=person.PartnershipDetails',
      ManagePartner: '/index.cfm?event=person.ManagePartners'
    },
    workflow:{
      myCompletableTasks: '/index.cfm?event=workflow.index'
    },
    expense: {
      buildExcel: 'index.cfm?event=property.getSearchExpenseResultsExcel'
    },
    auction: {
      changelog: {
        buildExcel: 'index.cfm?event=auction.getAuctionChangeLogResultsExcel'
      }
    }
  },
  paths: {
    PropertyId: 'cfvars:PropertyId',
    eqrf: 'cfvars:oEQRFTokenConfig:sTokenValue',
    LenderId: 'cfvars:LenderId',
    RelationshipId: 'cfvars:RelationshipId',
    PartnerUserPriv: 'cfvars:PartnerUserPriv',
    PersonId: 'cfvars:PersonId',
    eqcpcc: 'cfvars:eqcpcc',
    expenseSearchCriteria: 'cfvars:ExpenseSearch:ExpenseSearchCriteria',
    canAccessLibrary: 'cfvars:canAccessLibrary',
    canAccessOffer: 'cfvars:canAccessOffer',
    canAddMessage: 'cfvars:canAddMessage',
    canSendMessagesToExternal: 'cfvars:canSendMessagesToExternal',
    noteId: 'cfvars:noteId',
    messageCount: 'cfvars:messageCount',
    canViewMessages: 'cfvars:canViewMessages',
    canAccessExpense: 'cfvars:canAccessExpense',
    canAccessListPrice: 'cfvars:canAccessListPrice',
    OverView: 'cfvars:OverView',
    canViewHeaderSummary: 'cfvars:canViewHeaderSummary',
    UserFavoritePropertiesMaxCount: 'cfvars:UserFavoritePropertiesMaxCount',
    UserFavoritePropertiesCount: 'cfvars:UserFavoritePropertiesCount',
    taskSearchCriteria: 'cfvars:TaskSearch:TaskSearchCriteria',
    canViewNotes:'cfvars:canViewNotes',    
  }
};
